<template>
  <div class="creatcircle_containter">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>
    <div style="padding-top:50px;">
      <van-sticky :offset-top="50">
        <div class="creatcirclebox" @click="showModal" data-target="DialogModal1">
          <div class="creatrightbox">
            <img @click="showModal" data-target="DialogModal1" src="../../assets/images/home_icon_enter.png" />
          </div>
          <div class="creatleftbox">
            <img src="../../assets/images/circle_icon_qz.png" />
            <span @click="showModal" data-target="DialogModal1">申请圈子</span>
          </div>
        </div>
      </van-sticky>
      <div class="mycirclebox">
        <van-sticky :offset-top="111">
          <div class="mycirclethead">
            <div>圈子图</div>
            <div>分类</div>
            <div>名称</div>
            <div>审核状态</div>
            <div>操作</div>
          </div>
        </van-sticky>
        <div class="mycircletbody">
          <div class="nodynamiclist" v-if="applycirclelist.length==0">
            <div class="nofollowpic">
              <img src="../../assets/images/circle_icon_wu.png" />
            </div>
            <div class="nocircletext">暂时没有申请的圈子</div>
            <div class="gotofollow">
              <button @click="showModal" data-target="DialogModal1">立即去申请</button>
            </div>
          </div>
          <div v-else>
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <div class="mycircletcell" v-for="(item,index) in applycirclelist" :key="index">
                <div class="mycircleimg">
                  <img :src="item.avatar_url" />
                </div>
                <div>{{item.group_name.title}}</div>
                <div>{{item.like_title}}</div>
                <div>{{item.status_txt}}</div>
                <div class="reapply" v-if="item.status==2" @click="reapply" :data-likeid="item.id" data-target="DialogModal1">重新申请</div>
                <div v-else>--</div>
              </div>
            </van-list>
          </div>
        </div>
      </div>
      <div class="cu-modal" :class="modalName=='DialogModal1'?'show':'' ">
        <div class="cu-dialog">
          <div class="cu-bar bg-white justify-end">
            <div class="action" @click="hideModal">
              <img class="closeimg" src="../../assets/images/home_icon_close.png" />
            </div>
          </div>
          <div class="creatcirclemain">
            <div @click="cutImgChoose" data-type="avatar">
              <img :src="(avatar ==''? avatarPath : avatar)" class="upcropimage" />
            </div>
            <div class="creatcirclebd">
              <form @submit.prevent="formSubmit">
                <div class="circlenameinput" @click="showPicker = true">
                  <input readonly name="creatcirclename" v-model="pickervalue" placeholder="请选择圈子分类" />
                  <van-icon class="right_icon" name="play" />
                </div>
                <van-popup v-model="showPicker" position="bottom">
                  <van-picker show-toolbar :columns="picker" @cancel="showPicker = false" @confirm="onConfirm" :value-key="pickerkey" />
                </van-popup>
                <div class="circlenameinput">
                  <input name="creatcirclename" maxlength="10" v-model="creatcirclename" placeholder="请输入圈子名称" />
                </div>
                <div class="circlebtn">
                  <button class="submission" type="submit">提交</button>
                </div>
              </form>
            </div>
            <div class="rulesbox">
              <span class="ruletitle">申请规则</span>
              <div class="rulesmain">
                <span>1.名称不超过10个字，限汉字，字母和下划线；</span>
                <span>2.名称不能和已有圈子名称重复；</span>
                <span>3.圈子审核提交后，我们会在3-5个工作日审核；</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getApplycircle,
  getcircletype,
  getreapplycircle,
  getcreatcircle
} from "../../api/api";
import navbar from "../public/navbar.vue";
import Vue from "vue";
import { Picker, Icon, Toast } from "vant";
import { mapState, mapGetters } from "vuex";

Vue.use(Toast);
Vue.use(Icon);

Vue.use(Picker);
export default {
  name: "creatcircle",
  components: { navbar },
  data () {
    return {
      titlename: "申请圈子",
      modalName: "",
      applycirclelist: [
        {
          avatar_url:
            "https://api.xianpipa.com/uploads/avatars/likes/20190829/like_avatar_156704751497491021.png",
          group_name: { id: "2", title: "娱乐" },
          id: "96",
          like_title: "大象头像",
          status: "0",
          status_txt: "待审核"
        }
      ],
      pickervalue: "",
      showPicker: false,
      picker: ["娱乐", "生活", "时尚", "美食", "音乐"],
      pickerkey: "",
      allcirclelist: [
        { id: 2, title: "娱乐" },
        { id: 4, title: "生活" },
        { id: 8, title: "时尚" },
        { id: 9, title: "美食" },
        { id: 11, title: "音乐" }
      ],
      circleimgsrc: "", //圈子头像
      avatarPath: "https://api.xianpipa.com/xianpipa/images/circle_tx_pic.gif",
      creatcirclename: "",
      loading: false,
      finished: true,
      pageCount: 0,
      page: 0
    };
  },
  computed: {
    ...mapState(["avatar"])
  },
  created () {
    document.title = "创建名片";
    this.circleimgsrc = this.avatar;
    if (this.circleimgsrc != "") {
      this.modalName = "DialogModal1";
    }
    Toast.loading({
      mask: true,
      message: "加载中..."
    });
    this.getallapplycircle();
    this.onloaddata();
  },
  mounted () { },
  methods: {
    showModal: function (e) {
      this.modalName = e.target.dataset.target;
    },

    onLoad () {
      // 异步更新数据
      setTimeout(() => {
        let cirid = this.cirid;
        var page = this.page;
        let that = this;
        let pageCount = this.pageCount;
        page++;
        if (page > pageCount) {
          return;
        }
        this.page = page;

        getApplycircle(page).then(res => {
          if (res.data.code == 200) {
            this.loading = false;
            let myapplyarr = that.applycirclelist;
            let newarr = res.data.data.list;
            newarr.forEach(function (e) {
              myapplyarr.push(e);
            });
            this.finished = true;
          }
        });
      }, 500);
    },

    onloaddata () {
      //获取圈子分类
      let that = this;
      let newarray = [];
      let pickidarr = [];

      getcircletype().then(res => {
        if (res.data.code == 200) {
          let allpicker = res.data.data;
          this.allcirclelist = res.data.data;
          allpicker.forEach(element => {
            newarray.push(element.title);

            that.picker = newarray;
          });

          Toast.clear();
        } else {
          Toast("请刷新");
        }
      });
    },
    hideModal: function () {
      this.modalName = "";
      this.circleimgsrc = "";
      let avatar = "";
      this.$store.dispatch("changeAvatarFun", avatar);
    },
    cutImgChoose: function (e) {
      this.$router.push({
        name: "cropper",
        params: {
          type: e.currentTarget.dataset.type
        }
      });
    },
    //获取申请列表
    getallapplycircle () {
      getApplycircle().then(res => {
        if (res.data.code == 200) {
          let applycirclelist = res.data.data.list;
          this.pageCount = res.data.data.pageCount;

          this.finished = false;
          /* let applycirclelist =[
            {
              avatar_url:
                "https://api.xianpipa.com/uploads/avatars/likes/20190829/like_avatar_156704751497491021.png",
              group_name: { id: "2", title: "娱乐" },
              id: "96",
              like_title: "大象头像",
              status: "0",
              status_txt: "待审核"
            }
          ]; */
          if (applycirclelist.length === 0) {
            this.modalName = "DialogModal1";
          }
          this.applycirclelist = applycirclelist;
        } else if (res.code == 404) {
          this.modalName = "DialogModal1";
        } else {
          Toast("数据异常!");
        }
      }).catch(err => {
      });
    },
    //重新申请
    reapply: function () { },
    onConfirm (value, index) {
      this.pickervalue = value;
      this.pickerkey = String(index);
      this.showPicker = false;
    },
    //提交表单
    formSubmit: function (e) {
      const toast1 = Toast.loading({
        mask: true,
        message: "加载中..."
      });

      let that = this;
      if (this.circleimgsrc == "") {
        Toast({
          message: "请选择圈子头像",
          duration: 2000
        });
        return;
      } else if (this.pickerkey == "") {
        Toast({
          message: "请选择圈子分类",
          duration: 2000
        });
        return;
      } else if (this.creatcirclename == "") {
        Toast({
          message: "请输入圈子名称",
          duration: 2000
        });
        return;
      } else {
        let index = this.pickerkey;
        let group_id = this.allcirclelist[index].id;
        let title = this.creatcirclename;
        let avatar_url = this.circleimgsrc;
        let like_id = this.reapplyid; //重新申请
        //let avatar_url = this.upImgList

        let regStr = /[a-zA-Z_\u4e00-\u9fa5]+$/;
        if (!regStr.test(title)) {
          Toast({
            message: "名称不超过10个字，限汉字、字母和下划线",
            duration: 2000
          });
          //return;
        } else {
        }

        //提交
        if (like_id) {
          let formjson = {
            like_id: like_id,
            group_id: group_id,
            title: title,
            avatar_url: avatar_url
          };
          getreapplycircle(formjson).then(res => {
            if (res.code == 412) {
              Toast("圈子名字存在请换一个名称");
            } else if (res.code == 500) {
              Toast.fail("网络出错");
            } else {
              Toast.success({
                message: "成功文案",
                onClose: function () {
                }
              });
            }
          });
        } else {
          getcreatcircle(group_id, title, avatar_url).then(res => {
            toast1.clear();
            if (res.code == 412) {
              Toast("圈子名字存在请换一个名称");
            } else if (res.code == 500) {
              Toast.fail("网络出错");
            } else if (res.code == 200) {
              that.getallapplycircle();
              Toast.success({
                message: "提交成功",
                onClose: function () {

                }
              });
            }
          });
        }
      }

      //成功时删除数据
      let avatar = "";
      this.$store.dispatch("changeAvatarFun", avatar);
      this.modalName = "";
      this.circleimgsrc = "";
      this.pickerkey = "";
      this.creatcirclename = "";
    }
  }
};
</script>

<style scoped>
.creatcircle_containter {
  width: 100%;
  height: 100%;
  background: #f8f8f8;
}
.creatcirclebox {
  border-top: 0.02702702702702703rem solid #efefef;
  background: #fff;
  padding-bottom: 0.5405405405405406rem;
  overflow: hidden;
}
.creatcirclebox .creatrightbox {
  float: right;
  padding-right: 1.0810810810810811rem;
  padding-top: 1.0810810810810811rem;
}
.creatcirclebox .creatrightbox img {
  width: 0.3783783783783784rem;
  height: 0.7027027027027027rem;
}
.creatcirclebox .creatleftbox {
  float: left;
  padding-left: 0.9459459459459459rem;
  padding-top: 0.5405405405405406rem;
}
.creatcirclebox .creatleftbox img {
  width: 2.1621621621621623rem;
  height: 2.1621621621621623rem;
  float: left;
}
.creatcirclebox .creatleftbox span {
  float: left;
  font-size: 0.7567567567567568rem;
  font-weight: bold;
  padding-left: 0.918918918918919rem;
  padding-top: 0.5135135135135135rem;
}
.mycirclebox {
  width: 100%;
  background: #fff;
}
.mycirclebox .mycirclethead {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  border-top: 0.40540540540540543rem solid #f8f8f8;
  border-bottom: 0.02702702702702703rem solid #e9e9e9;
  background: #fff;
}
.mycirclebox .mycirclethead div {
  width: 20%;
  flex: 0 0 20%;
  text-align: center;
  color: #666666;
  padding-top: 0.5405405405405406rem;
  padding-bottom: 0.5405405405405406rem;
  font-size: 0.7027027027027027rem;
}
.closeimg {
  width: 1.3513513513513513rem;
  height: 1.3513513513513513rem;
  position: absolute;
  top: 1.054054054054054rem;
  right: 1.027027027027027rem;
}
.upcircletx {
  left: 0;
}
.mycirclebox .mycircletbody {
  background: #fff;
  padding-top: 0.7rem;
}
.mycirclebox .mycircletbody .mycircletcell {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  border-bottom: 0.02702702702702703rem solid #f3f3f3;
}
.mycirclebox .mycircletbody .mycircletcell div {
  width: 20%;
  flex: 0 0 20%;
  text-align: center;
  color: #333333;
  padding-top: 0.5405405405405406rem;
  padding-bottom: 0.5405405405405406rem;
  font-size: 0.7027027027027027rem;
}
.mycirclebox .mycircletbody .mycircletcell div.mycircleimg {
}
.mycirclebox .mycircletbody .mycircletcell div.mycircleimg img {
  width: 2.108108108108108rem;
  height: 2.108108108108108rem;
  border-radius: 0.2702702702702703rem;
}
.mycirclebox .mycircletbody .mycircletcell div.reapply {
  color: #6699ff;
}
.creatcirclemain {
  background: #fff;
  margin-top: -0.5945945945945946rem;
}
.creatcirclemain .upcropimage {
  width: 4.216216216216216rem;
  height: 4.216216216216216rem;
  border-radius: 0.40540540540540543rem;
}
.creatcirclemain .creatcirclebd {
  width: 15.135135135135135rem;
  margin: 0 auto;
  padding-top: 0.6756756756756757rem;
}
.creatcirclemain .creatcirclebd .classifybox {
  border: 1px solid #e4e4e4;
  height: 2.3513513513513513rem;
  border-radius: 0.5405405405405406rem;
}
.creatcirclemain .creatcirclebd .classifybox .picker {
  text-align: left;
  padding-left: 0.8108108108108109rem;
}
.creatcirclemain .creatcirclebd .classifybox .picker .cuIcon-triangledownfill {
  float: right;
  padding-right: 0.5405405405405406rem;
  color: #999;
  font-size: 1.0810810810810811rem;
}
.creatcirclemain .creatcirclebd .circlenameinput {
  padding-top: 0.7567567567567568rem;
  position: relative;
}
.creatcirclemain .creatcirclebd .circlenameinput input {
  border: 1px solid #e4e4e4;
  height: 2.3513513513513513rem;
  border-radius: 0.5405405405405406rem;
  text-align: left;
  padding-left: 0.8108108108108109rem;
  color: #333;
  line-height: 2.3513513513513513rem;
  font-size: 14px;
  width: calc(100% - 0.8108108108108109rem);
  -webkit-appearance: none;
}
.creatcirclemain .creatcirclebd .circlenameinput .right_icon {
  width: 11px;
  height: 20px;
  position: absolute;
  top: 25px;
  right: 20px;
  transform: rotate(90deg);
  font-size: 14px;
  color: #666;
}
.creatcirclemain .creatcirclebd .circlebtn {
  padding-top: 0.8108108108108109rem;
}
.creatcirclemain .creatcirclebd .circlebtn .submission {
  height: 2.4324324324324325rem;
  font-size: 0.8108108108108109rem;
  color: #ffffff;
  line-height: 2.4324324324324325rem;
  border-radius: 1.3513513513513513rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  width: 100%;
  border: 0;
}
.creatcirclemain .rulesbox {
  padding-top: 0.8108108108108109rem;
  text-align: left;
  padding-left: 1.6216216216216217rem;
  padding-right: 1.6216216216216217rem;
  padding-bottom: 1.3513513513513513rem;
}
.creatcirclemain .rulesbox span.ruletitle {
  font-size: 0.7567567567567568rem;
  padding-bottom: 0.5405405405405406rem;
  color: #666666;
}
.creatcirclemain .rulesbox .rulesmain {
  padding-top: 0.2702702702702703rem;
  line-height: 1.0810810810810811rem;
}
.creatcirclemain .rulesbox .rulesmain span {
  display: block;
  font-size: 0.7027027027027027rem;
  color: #999999;
}
button:after {
  border: none;
}
.nodynamiclist {
  padding-top: 3.702703rem;
}
.nodynamiclist .nofollowpic {
  text-align: center;
}
.nodynamiclist .nocircletext {
  text-align: center;
  padding-top: 0.651351rem;
  font-size: 0.7567567567567568rem;
  color: #999;
}
.nodynamiclist .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nodynamiclist .gotofollow {
  text-align: center;
}
.nodynamiclist .gotofollow button {
  width: 5.405405405405405rem;
  height: 1.8918918918918919rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  font-size: 0.7567567567567568rem;
  color: #fff;
  border: 0;
  margin-top: 1.027027rem;
  border-radius: 0.2rem;
}

/* ================== 模态窗口 ==================== */
.cu-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1110;
  opacity: 0;
  outline: 0;
  text-align: center;
  -ms-transform: scale(1.185);
  transform: scale(1.185);
  backface-visibility: hidden;
  perspective: 54.054054054054056rem;
  background: rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease-in-out 0s;
  pointer-events: none;
}
.cu-modal::before {
  content: "\200B";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.cu-modal.show {
  opacity: 1;
  transition-duration: 0.3s;
  -ms-transform: scale(1);
  transform: scale(1);
  overflow-x: hidden;
  overflow-y: auto;
  pointer-events: auto;
}
.cu-dialog {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: auto;
  margin-right: auto;
  width: 18.37837837837838rem;
  max-width: 100%;
  background-color: #f8f8f8;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
}
.cu-modal.bottom-modal::before {
  vertical-align: bottom;
}
.cu-modal.bottom-modal .cu-dialog {
  width: 100%;
  border-radius: 0;
}
.cu-modal.bottom-modal {
  margin-bottom: -27.027027027027028rem;
}
.cu-modal.bottom-modal.show {
  margin-bottom: 0;
}
.cu-modal.drawer-modal {
  transform: scale(1);
  display: flex;
}
.cu-modal.drawer-modal .cu-dialog {
  height: 100%;
  min-width: 5.405405405405405rem;
  border-radius: 0;
  margin: initial;
  transition-duration: 0.3s;
}
.cu-modal.drawer-modal.justify-start .cu-dialog {
  transform: translateX(-100%);
}
.cu-modal.drawer-modal.justify-end .cu-dialog {
  transform: translateX(100%);
}
.cu-modal.drawer-modal.show .cu-dialog {
  transform: translateX(0%);
}
.cu-modal .cu-dialog > .cu-bar:first-child .action {
  min-width: 2.7027027027027026rem;
  margin-right: 0;
  min-height: 2.7027027027027026rem;
  background: #fff;
}
</style>

<style>
.van-field__right-icon .van-icon-play {
  transform: rotate(90deg);
}
/* .van-cell {
  border: 1px solid #e4e4e4;
  height: 2.3513513513513513rem;
  border-radius: 0.5405405405405406rem;
} */
</style>


// WEBPACK FOOTER //
// src/components/pages/creatcircle.vue